import { logger } from '@inboundx/shared/platform';

// Polyfills for browser environment

type BrowserRequire = (module: string) => unknown;
type BrowserWindowWithPolyfills = Window & {
    global?: typeof globalThis;
    require?: BrowserRequire;
};

// Polyfill for require() if needed by some libraries
if (typeof window !== 'undefined') {
    const browserWindow = window as BrowserWindowWithPolyfills;

    if (!browserWindow.require) {
        browserWindow.require = (module: string) => {
            console.warn(
                `require() is not available in browser environment. Attempted to require: ${module}`
            );

            // Return different types based on common module patterns
            if (module.includes('constants') || module.includes('config')) {
                // For config/constants modules, return the actual constants from the shared module
                // This mimics what the require would have returned
                try {
                    // Import the constants dynamically if available
                    import('@inboundx/shared/config')
                        .then((sharedModule) => {
                            logger.debug('Shared module loaded:', sharedModule);
                        })
                        .catch(() => {});

                    // Return the actual constants structure
                    return {
                        API_VERSION: '1.2.0',
                        SUPPORTED_SITES: {
                            'abtasty.com': { name: 'ABTasty', color: '#3100BE' },
                            default: { name: 'Default', color: '#0A42C3' },
                        },
                        COMMON_API_CONFIG: {
                            rose_api_url: '',
                            rose_api_key: '',
                        },
                        DEFAULT_CONFIG: {
                            API_URL: 'http://localhost:8080',
                            SITE_NAME: 'ABTasty',
                            DOMAIN: 'abtasty.com',
                        },
                        default: {}, // CommonJS default export
                    };
                } catch {
                    console.warn('Could not load constants, using fallback');
                    return {
                        API_VERSION: '1.2.0',
                        DEFAULT_CONFIG: {},
                        CONSTANTS: {},
                        default: {},
                    };
                }
            }

            // For other modules, return a more flexible object that can be called as a function
            const mockModule = (...args: unknown[]) => {
                console.warn(`Mock function called for required module: ${module}`, args);
                return {};
            };

            // Add common properties that modules might expect
            Object.assign(mockModule, {
                default: mockModule,
                exports: {},
                module: { exports: {} },
            });

            return mockModule;
        };
    }

    // Ensure global is available
    if (!browserWindow.global) {
        browserWindow.global = window;
    }
}
